<mat-form-field class="w-100" [appearance]="appearance">
  <mat-label>{{ 'Select_Language_tr' | translate }}</mat-label>
  <mat-select data-testid="language-dropdown" [formControl]="control">
    @for (lang of options; track lang.code) {
      <mat-option [value]="lang.code" [attr.data-testid]="'lang-' + lang.code">
        <img [src]="'../assets/i18n/flag_i18n_' + lang.flag + '.svg'" class="icon-lang" [alt]="lang.flag" />
        {{ lang.label }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
